import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const d = (r) => r.data;

export const contractsApi = {
  list: () => axios.get(`${API}/contracts`).then(d),
  get: (id) => axios.get(`${API}/contracts/${id}`).then(d),
  create: (b) => axios.post(`${API}/contracts`, b).then(d),
  update: (id, b) => axios.put(`${API}/contracts/${id}`, b).then(d),
  remove: (id) => axios.delete(`${API}/contracts/${id}`).then(d),
  send: (id) => axios.post(`${API}/contracts/${id}/send`).then(d),
  revoke: (id) => axios.post(`${API}/contracts/${id}/revoke`).then(d),
  uploadSignature: (id, file, name) => { const f = new FormData(); f.append("file", file); f.append("name", name || ""); return axios.post(`${API}/contracts/${id}/upload-signature`, f).then(d); },
  types: () => axios.get(`${API}/contracts-meta/types`).then(d),
};

// Streams AI output (SSE); calls onText with the accumulated text.
export const streamContractAI = async (body, onText) => {
  const res = await fetch(`${API}/contracts/ai`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (!res.ok) {
    let msg = "تعذّر تشغيل المساعد";
    try { msg = (await res.json()).detail || msg; } catch { /* ignore */ }
    throw new Error(msg);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", text = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const ev = JSON.parse(p.slice(6));
      if (ev.error) throw new Error(ev.error);
      if (ev.t) { text += ev.t; onText(text); }
    }
  }
  return text.replace(/^```(?:html)?\s*|\s*```$/g, "").trim();
};
